import { combineReducers } from "redux";
import AllReducers from "./actions";

const rootReducer = combineReducers({ ...AllReducers });

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/rootReducers.js